import { render, staticRenderFns } from "./DeanAdmissionsStudentList.vue?vue&type=template&id=bce1952c&scoped=true"
import script from "./DeanAdmissionsStudentList.vue?vue&type=script&lang=js"
export * from "./DeanAdmissionsStudentList.vue?vue&type=script&lang=js"
import style0 from "./DeanAdmissionsStudentList.vue?vue&type=style&index=0&id=bce1952c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce1952c",
  null
  
)

export default component.exports